import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global hash scroll handler.
 * Mount once under BrowserRouter.
 * Smooth-scrolls to #id on route change or direct load.
 * Retries to handle dynamically loaded content that shifts layout.
 */
export const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");
    if (!id) return;

    const scrollTo = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    // Initial attempt after route render
    const t1 = setTimeout(scrollTo, 150);
    // Retry after async content likely loaded
    const t2 = setTimeout(scrollTo, 600);
    const t3 = setTimeout(scrollTo, 1500);

    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [pathname, hash]);

  return null;
};
